import {FieldMap, FieldOperations, OpsCategories, SqlOperation, TableI} from "../Types";
import {nanoid} from "@reduxjs/toolkit";
import {GREEN_COLOR, GREEN_LIGHT_COLOR, RED_COLOR, SELECT_BACK_COLOR, YELLOW_COLOR} from "../components/CONSTANTS";
import moment from "moment/moment";


const inmsgStatusMap = {
    groups: [
        {
            label: {
                ua: "Коректні",
            },
            values: ["OK"]
        },
        {
            label: {
                ua: "Невідомо",
            },
            values: ["UNKNOWN", "NEW"]
        },
        {
            label: {
                ua: "Некоректні",
            },
            values: ["DUPLICATE", "BAD_QUALITY", "DO_NOT_MATCH", "OTHER"]
        }],
    //backgroundColor: '#18111c',
    backgroundColor: SELECT_BACK_COLOR,
    values: {
        "OK": {
            rawValue: "OK",
            lang: {
                ua: "ОК",
            },
            color: GREEN_COLOR
        },
        "UNKNOWN": {
            rawValue: "UNKNOWN",
            lang: {
                ua: "Невідомий",
            },
            color: YELLOW_COLOR
        },
        "NEW": {
            rawValue: "NEW",
            lang: {
                ua: "Новий",
            },
            color: GREEN_LIGHT_COLOR
        },
        "DO_NOT_MATCH": {
            rawValue: "DO_NOT_MATCH",
            lang: {
                ua: "Не відповідає умовам",
            },
            color: RED_COLOR
        },
        "DUPLICATE": {
            rawValue: "DUPLICATE",
            lang: {
                ua: "Дублікат",
            },
            color: "#ee8517"
        },
        "BAD_QUALITY": {
            rawValue: "BAD_QUALITY",
            lang: {
                ua: "Погана якість",
            },
            color: RED_COLOR
        },
        "OTHER": {
            rawValue: "OTHER",
            lang: {
                ua: "Інше",
            },
            color: RED_COLOR
        },
    }
} as FieldMap;

export const act343PrizeMap = {
    values: {
        "1": {
            rawValue: "1",
            lang: {
                ua: "Електронний сертифікат «Сільпо» номінальної вартості 300 грн",
            },
        },
        "2": {
            rawValue: "2",
            lang: {
                ua: "Пристрій для дистанційної гри PlayStation Portal",
            },
        },
        "3": {
            rawValue: "3",
            lang: {
                ua: "Консоль Play Station 5",
            },
        },
    }
} as FieldMap;

let fieldOperations: FieldOperations = {
    status: [...OpsCategories.in],
    msisdn: [...OpsCategories.eq, ...OpsCategories.like, ...OpsCategories.in,],
    email: [...OpsCategories.eq, ...OpsCategories.like, ...OpsCategories.in,],
    check_serial: [...OpsCategories.eq, ...OpsCategories.like, ...OpsCategories.in,],
    date: [...OpsCategories.range],
    prize_id: [...OpsCategories.null, ...OpsCategories.in],
    all_prizes: [...OpsCategories.like],
    prize_dt: [...OpsCategories.range],
    unique_id: [...OpsCategories.eq, ...OpsCategories.null],
    device: [...OpsCategories.like],
    os: [...OpsCategories.like],
    ip: [...OpsCategories.eq],
    dt: [...OpsCategories.range],
    unique_check: [...OpsCategories.eq],
    email_sent: [...OpsCategories.eq, ...OpsCategories.null],
    email_sent_dt: [...OpsCategories.range],
    count_reg: [...OpsCategories.range],
    qr_code: [...OpsCategories.null],
    id: [...OpsCategories.eq, ...OpsCategories.range, ...OpsCategories.in,],
};
export const ImnsgTable: TableI = {
    backend: "/343/",
    title: {
        ua: "Реєстрації",
        en: "Замовлення",
    },
    pk: 'id',
    defaultOrderedBy: "dt",
    defaultOrderedWay: "ASC",
    defaultPerPage: 20,
    orderByFields: {
        "id": {ua: "ID", en: "№"},
        "dt": {ua: "Створено", ru: "Дата"},
        "count_reg": {ua: "Кількість реєстрацій", ru: "Дата"},
        "date": {ua: "Дата", ru: "Дата"},
    },
    fieldOperations: fieldOperations,
    defaultFilters: 'inmsg343DefFilters',
    action: "inmsg343SetWinners",
    fields: [
        {
            key: "n",
            inline: true,
            title: {ua: "№"}, type: "number",
            applyTransform: true
        },
        {
            key: "id",
            detailed: true,
            title: {ua: "ID"},
            type: "number",
            applyTransform: true
        },
        {
            key: "dt",
            title: {ua: "Створено"},
            type: "datetime",
            datetimeFormat: "DD MMMM YYYY HH:mm",
            applyTransform: true,
            detailed: false,
            inline: true,
        },
        {
            key: "msisdn", type: 'tel',
            editable: true,
            applyTransform: true,
            detailed: true, inline: true, title: {ua: "Телефон"}
        },
        {
            key: "first_name", type: 'string',
            editable: true,
            applyTransform: true,
            detailed: true, inline: true, title: {ua: "Ім'я"}
        },
        {
            key: "last_name", type: 'string',
            editable: true,
            applyTransform: true,
            detailed: true, inline: true, title: {ua: "Прізвище"}
        },
        {
            key: "email", type: 'email',
            editable: true,
            applyTransform: true,
            detailed: true, inline: true, title: {ua: "Email"}
        },
        {
            key: "date", type: 'date',
            editable: true,
            applyTransform: true,
            datetimeFormat: "DD MMMM",
            detailed: true, inline: true, title: {ua: "Дата"}
        },

        {
            key: "status", type: 'map',
            map: inmsgStatusMap,
            applyTransform: true,
            editable: true,
            detailed: true,
            inline: true,
            title: {ua: "Статус"}
        },
        {
            key: "unique_id",
            detailed: true,
            title: {ua: "Унікальний ідентифікатор"},
            type: 'string',
            editable: true,
            updateSingleFieldPath: 'updateUniqueId.php',
            comment: 'ФН чека (пробіл) ФН ПРРО',
            getColumnValue: "uniqueId343Qr",
            applyTransform: true,
            nullable: true
        },
        {
            key: "check_serial",
            detailed: true,
            title: {ua: "Номер чека"},
            type: 'string',
            editable: true,
            applyTransform: true
        },
        {
            key: "unique_check",
            detailed: true,
            title: {ua: "Унікальний чек"},
            type: 'boolean',
            applyTransform: true,
            comment: "Чи відсутній чек з таким же номером"
        },
        {
            key: "check_photo",
            detailed: true,
            title: {ua: "Чек"},
            type: 'image',
            applyTransform: true,
            imageMaxHeight: 450,
            imageMaxWidth: 550
        },
        {
            key: "qr_code",
            detailed: true,
            editable: true,
            nullable: true,
            title: {ua: "QR"},
            type: 'url',
            applyTransform: true
        },
        {
            key: "count_reg", type: 'number',
            applyTransform: true,
            detailed: true, inline: true, title: {ua: "Кількість реєстрацій"}
        },
        {
            key: "comment", title: {ua: "Коментар"}, type: 'string',
            editable: true, nullable: true,
            applyTransform: true
        },
        {
            key: "have_prize",
            title: {ua: "Має вже приз"},
            type: 'boolean',
            applyTransform: true
        },
        {
            key: "all_prizes",
            getColumnValue: 'inmsg343AllPrizesFields',
            applyTransform: true,
            title: {ua: "Всі призи"},
            type: 'string'
        },
        {
            key: "prize_id", title: {ua: "Приз"}, type: 'map',
            map: act343PrizeMap,
            editable: true, nullable: true,
            applyTransform: true
        },
        {
            key: "prize_dt", title: {ua: "Час виграшу"},
            type: "datetime",
            datetimeFormat: "DD MMMM YYYY HH:mm",
            applyTransform: true,
            editable: true,
            nullable: true,
            detailed: true
        },
        {
            key: "email_sent",
            title: {ua: "Емейл відправлено"},
            type: 'boolean',
            applyTransform: true
        },
        {
            key: "email_sent_dt",
            title: {ua: "Час емейлу"},
            type: "datetime",
            datetimeFormat: "DD MMMM YYYY HH:mm",
            applyTransform: true,
            detailed: true
        },
        {
            key: "ip", title: {ua: "IP"}, type: 'string', detailed: true, inline: false
        },
        {
            key: "os", title: {ua: "ОС"}, type: 'string', detailed: true, inline: false
        },
        {
            key: "device", title: {ua: "Девайс"}, type: 'string', detailed: true, inline: false
        },

    ]
}

export function inmsg343DefFilters() {
    return [
        {
            nanoid: nanoid(),
            field: 'status',
            type: 'map',
            filterOp: SqlOperation.IN,
            locked: true,
            value: ['UNKNOWN', 'NEW']
        }
    ]
}

export function inmsg343SilpoFilters() {
    return [
        {
            nanoid: nanoid(),
            field: 'status',
            type: 'map',
            filterOp: SqlOperation.IN,
            locked: true,
            value: ['OK']
        },
        {
            nanoid: nanoid(),
            field: 'dt',
            type: 'datetime',
            filterOp: SqlOperation.GREATER_THAN_OR_EQUAL,
            locked: true,
            value: moment().subtract(1, 'days').startOf('day').format('yyyy-MM-DD HH:mm:ss')
        },
        {
            nanoid: nanoid(),
            field: 'dt',
            type: 'datetime',
            filterOp: SqlOperation.LESS_THAN,
            locked: true,
            value: moment().startOf('day').locale('en').format('yyyy-MM-DD HH:mm:ss')
        },
        {
            nanoid: nanoid(),
            field: 'all_prizes',
            type: 'string',
            filterOp: SqlOperation.NOT_LIKE,
            locked: true,
            value: '1'
        },
        {
            nanoid: nanoid(),
            field: 'prize_id',
            type: 'boolean',
            filterOp: SqlOperation.IS_NULL,
            locked: true,
            value: true
        },
    ]
}

export function inmsg343PortalFilters() {
    return [
        {
            nanoid: nanoid(),
            field: 'status',
            type: 'map',
            filterOp: SqlOperation.IN,
            locked: true,
            value: ['OK']
        },
        {
            nanoid: nanoid(),
            field: 'dt',
            type: 'datetime',
            filterOp: SqlOperation.GREATER_THAN_OR_EQUAL,
            locked: true,
            value: moment().subtract(7, 'days').startOf('day').format('yyyy-MM-DD HH:mm:ss')
        },
        {
            nanoid: nanoid(),
            field: 'dt',
            type: 'datetime',
            filterOp: SqlOperation.LESS_THAN,
            locked: true,
            value: moment().startOf('day').locale('en').format('yyyy-MM-DD HH:mm:ss')
        },

        {
            nanoid: nanoid(),
            field: 'all_prizes',
            type: 'string',
            filterOp: SqlOperation.NOT_LIKE,
            locked: true,
            value: '2'
        },
        {
            nanoid: nanoid(),
            field: 'prize_id',
            type: 'boolean',
            filterOp: SqlOperation.IS_NULL,
            locked: true,
            value: true
        },
    ]
}

export function inmsg343Ps5Filters() {
    return [
        {
            nanoid: nanoid(),
            field: 'status',
            type: 'map',
            filterOp: SqlOperation.IN,
            locked: true,
            value: ['OK']
        },

        {
            nanoid: nanoid(),
            field: 'all_prizes',
            type: 'string',
            filterOp: SqlOperation.NOT_LIKE,
            locked: true,
            value: '3'
        },
        {
            nanoid: nanoid(),
            field: 'prize_id',
            type: 'boolean',
            filterOp: SqlOperation.IS_NULL,
            locked: true,
            value: true
        },
    ]
}

